<div *ngIf="localities.length > 2 || zones.length" class="filter-pane">
  <h1>{{'Filter' | translate}}</h1>
  <div class="column">
    <app-object-dropdown class="width-80" [mode]="userZone ? Mode.readonly : Mode.edition" [label]="'Zone'"
      [object]="zone" [objects]="zones" (objectChange)="onZone($event)"></app-object-dropdown>
    <app-object-dropdown class="width-80" [label]="'Locality'"
      [object]="locality" [objects]="localities" (objectChange)="onLocality($event)"></app-object-dropdown>
  </div>
</div>
